import { render, staticRenderFns } from "./RallyRegisterTShirtSize.vue?vue&type=template&id=2607f0f9&"
import script from "./RallyRegisterTShirtSize.vue?vue&type=script&lang=ts&"
export * from "./RallyRegisterTShirtSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports